var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { env } from '@funny/env';
import { OutsideBar } from '@funny/widgets';
import { openApp } from '@funny/cross-platform';
import { bridge } from '@funny/bridge';
import { get } from '@funny/request';
import qs from 'qs';
/**
 * 设置唱吧分享
 * @param shareParams 分享参数，thumburl是客户端需要的一个参数，SDK内部直接收敛，开发者无需关心
 */
export function share(shareParams) {
    var _a, _b, _c, _d, _e, _f;
    shareParams.thumburl = shareParams.imageurl;
    try {
        if (env.browser.isIOS) {
            (_d = (_c = (_b = (_a = window.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.issueShareUrlParams) === null || _c === void 0 ? void 0 : _c.postMessage) === null || _d === void 0 ? void 0 : _d.call(_c, JSON.stringify(shareParams));
        }
        else {
            // Android分享到唱吧，缩略图不显示问题
            (_f = (_e = window.changbaCaller) === null || _e === void 0 ? void 0 : _e.issueShareUrlParams) === null || _f === void 0 ? void 0 : _f.call(_e, JSON.stringify(shareParams));
        }
        window.shareCallback = function () {
            typeof shareParams.shareCallback === 'function' && shareParams.shareCallback();
        };
    }
    catch (exp) {
        console.log(exp);
    }
    // 处理微信内部分享的缩略图和url
    setWXConfig({
        title: shareParams.title,
        desc: shareParams.content,
        link: shareParams.targeturl,
        imgUrl: shareParams.imageurl,
    });
}
/**
 * 配置微信分享参数
 * @param param0
 * @returns
 */
function setWXConfig(_a) {
    var _b, _c;
    var title = _a.title, desc = _a.desc, link = _a.link, imgUrl = _a.imgUrl;
    return __awaiter(this, void 0, void 0, function () {
        var resp, data;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!env.browser.isQQorWeChat) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, get({
                            url: '/api/wechat/share/getSignPackage',
                            ignoreBaseURL: true,
                            data: {
                                fromUrl: window.location.href.split('#')[0],
                            },
                        })];
                case 1:
                    resp = _d.sent();
                    data = resp.data;
                    if (resp.code === 1) {
                        (_b = window.wx) === null || _b === void 0 ? void 0 : _b.config({
                            debug: false,
                            appId: data.appId,
                            timestamp: data.timestamp,
                            nonceStr: data.nonceStr,
                            signature: data.signature,
                            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'],
                            openTagList: ['wx-open-launch-app'],
                        });
                        (_c = window.wx) === null || _c === void 0 ? void 0 : _c.ready(function () {
                            var _a, _b;
                            var shareData = {
                                title: title,
                                imgUrl: imgUrl,
                                desc: desc,
                                cancel: function () { },
                                link: link,
                                success: function () { },
                            };
                            (_a = window.wx) === null || _a === void 0 ? void 0 : _a.updateTimelineShareData(shareData);
                            (_b = window.wx) === null || _b === void 0 ? void 0 : _b.updateAppMessageShareData(shareData);
                        });
                    }
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * 手动调起分享面板
 * @param shareParams 分享参数
 */
export function invokeShareByManual(shareParams) {
    var title = encodeURIComponent(shareParams.title);
    var content = encodeURIComponent(shareParams.content);
    // 找到问号出现的位置
    var quesIdx = shareParams.targeturl.indexOf('?');
    // 读取到查询字符串
    var queryString = quesIdx < 0 ? '' : shareParams.targeturl.slice(quesIdx + 1);
    var otherParams = shareParams.otherParams || {};
    // 合并所有的参数
    var paredParams = __assign(__assign({
        extraOperate: '012',
        isNeedPause: '1',
        show_mode: 'present',
        container_background_color: '00000000',
        businesstype: '0',
    }, otherParams), qs.parse(queryString));
    var newQueryString = qs.stringify(paredParams);
    var url = quesIdx < 0
        ? shareParams.targeturl + '?&' + newQueryString
        : shareParams.targeturl.slice(0, quesIdx) + '?&' + newQueryString;
    var targetUrl = encodeURIComponent(url);
    var imageUrl = encodeURIComponent(shareParams.imageurl);
    bridge.openPage("changba://?ac=addshare&title=".concat(title, "&content=").concat(content, "&targeturl=").concat(targetUrl, "&imageurl=").concat(imageUrl), false);
}
/**
 * 向Clipboard写入内容
 * @param {string} text 写入剪贴板的内容
 */
export function setTextIntoClipboard(text) {
    return __awaiter(this, void 0, void 0, function () {
        var exp_1, tmpInput;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, navigator.clipboard.writeText(text)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    exp_1 = _a.sent();
                    tmpInput = document.createElement('input');
                    document.body.appendChild(tmpInput);
                    tmpInput.value = text;
                    /* 需要让这个input是可见的，不能将其设置为visibility为hidden或者display为none */
                    tmpInput.style.left = 'absolute';
                    tmpInput.style.left = '10000px';
                    tmpInput.style.top = '10000px';
                    tmpInput.select();
                    typeof document.execCommand === 'function' && document.execCommand('copy');
                    document.body.removeChild(tmpInput);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function initOutsideBar() {
    new OutsideBar({
        openApp: openApp,
    });
}
export * from './file';
export * from './datetime';
export * from './resource/index';
export * from './image';
export * from './adaptor';
